import React from "react";
import styles from "./FranchiseTableHeader.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {FranchiseTableSortingField} from "../../../../../api/generated";
import {SortableHeaderCell, TableSort} from "../../../../elements/sortableHeaderCell/SortableHeaderCell";
import {franchiseTableRequestSelector, updateFranchiseTableRequest} from "../../franchiseSlice";

export const FranchiseTableHeader: React.FC = () => {
    const dispatch = useAppDispatch()
    const {sortBy, sortDirection} = useAppSelector(franchiseTableRequestSelector)
    const sort: TableSort<FranchiseTableSortingField> = {sortBy, sortDirection}

    const handleSort = (nextSort: TableSort<FranchiseTableSortingField>) => {
        dispatch(updateFranchiseTableRequest(nextSort))
    }

    return <div className={styles.wrapper}>
        <SortableHeaderCell className={styles.nameCell} title={"Name"} sortKey={FranchiseTableSortingField.Name} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.hashCell} title={"Hash"} sortKey={FranchiseTableSortingField.Hash} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.urlPatternCell} title={"URL Pattern"} sortKey={FranchiseTableSortingField.UrlPattern} sort={sort} onSort={handleSort}/>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
